import React, { useEffect, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import GridLayout, { Responsive, WidthProvider } from 'react-grid-layout'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import {
  IFFilter,
  IFsvg,
  GraphCard,
  OverviewCard,
  TopCitiesCard,
  TopSitesCard,
  TopUsersCard,
  TopVouchersCard,
  UsersActivityCard,
  TimeBetweenTransCard,
  TimeForFirstChargeCard,
  AverageDurationCard,
  TransactionsStatsCard,
  UsersStatisticsCard,
  PaymentBreakdownCard,
  PeakHourCard,
  UserSignupHeatmap,
  EnergyChartCard,
} from 'Components'
import Colors from 'Theme/Colors'
import Styles from './DashboardPage.module.css'
import { useTranslation } from 'react-i18next'
import { Scrollbars } from 'react-custom-scrollbars'
import LoadingBar from 'react-top-loading-bar'
import AuthSelectors from 'Stores/Auth/Selectors'
import { Actions, Subjects } from 'Enums/permissionKeys'
import IFFilterType from 'Enums/IFFilterType'

const ResponsiveGridLayout = WidthProvider(Responsive)

const layouts = {
  lg: [
    { i: 'OverView', x: 0, y: 0, w: 2.5, h: 2, static: true },
    { i: 'PeakHour', x: 0, y: 3.25, w: 1.25, h: 2, static: true },
    { i: 'TopSites', x: 2.5, y: 0, w: 1.5, h: 3.25, static: true },
    { i: 'TransactionsStats', x: 0, y: 2, w: 2.5, h: 1.25, static: true },
    { i: 'UsersStats', x: 1.25, y: 5.25, w: 2.75, h: 1, static: true },
    { i: 'TopCities', x: 1.25, y: 3.25, w: 1.5, h: 2, static: true },
    { i: 'TimeFirstTrans', x: 2.75, y: 3.25, w: 1.25, h: 2, static: true },
    { i: 'AverageDuration', x: 0, y: 5.25, w: 1.25, h: 1, static: true },
    { i: 'EnergyChart', x: 0, y: 6.25, w: 2.5, h: 1.5, static: true },
    { i: 'UsersActivity', x: 2.5, y: 6.25, w: 1.5, h: 1.5, static: true },
    { i: 'PaymentBreakdown', x: 2, y: 7.75, w: 2, h: 1.5, static: true },
    { i: 'UserSignup', x: 0, y: 7.75, w: 2, h: 1.5, static: true },
    { i: 'TimeBetweenTrans', x: 1.25, y: 9.25, w: 1.5, h: 2, static: true },
    { i: 'TopUsers', x: 0, y: 9.25, w: 1.25, h: 2, static: true },
    { i: 'TopVouchers', x: 2.75, y: 9.25, w: 1.25, h: 2, static: true },
  ],
  md: [
    { i: 'OverView', x: 0, y: 0, w: 2, h: 2 },
    { i: 'TransactionsStats', x: 0, y: 2, w: 2, h: 1.25 },
    { i: 'UsersStats', x: 0, y: 3.25, w: 2, h: 1 },
    { i: 'PeakHour', x: 0, y: 4.25, w: 1, h: 2 },
    { i: 'TopCities', x: 1, y: 4.25, w: 1, h: 2 },
    { i: 'TopSites', x: 0, y: 6.25, w: 2, h: 3.25 },
    { i: 'TimeFirstTrans', x: 0, y: 9.5, w: 1, h: 2 },
    { i: 'TopVouchers', x: 1, y: 9.5, w: 1, h: 2 },
    { i: 'EnergyChart', x: 0, y: 12.5, w: 2, h: 2 },
    { i: 'UsersActivity', x: 0, y: 14.5, w: 2, h: 2 },
    { i: 'PaymentBreakdown', x: 0, y: 16.5, w: 2, h: 2 },
    { i: 'UserSignup', x: 0, y: 18.5, w: 2, h: 2 },
    { i: 'TimeBetweenTrans', x: 0, y: 20.5, w: 1, h: 2 },
    { i: 'TopUsers', x: 1, y: 21.5, w: 1, h: 2 },
    { i: 'AverageDuration', x: 0, y: 22.5, w: 2, h: 1 },
  ],
  sm: [
    { i: 'OverView', x: 0, y: 0, w: 1, h: 2 },
    { i: 'TransactionsStats', x: 0, y: 2, w: 1, h: 1.25 },
    { i: 'UsersStats', x: 0, y: 3.25, w: 1, h: 1 },
    { i: 'PeakHour', x: 0, y: 4.25, w: 1, h: 2 },
    { i: 'TopCities', x: 0, y: 6.25, w: 1, h: 2 },
    { i: 'TopSites', x: 0, y: 8.25, w: 1, h: 3.25 },
    { i: 'TimeFirstTrans', x: 0, y: 11.5, w: 1, h: 2 },
    { i: 'AverageDuration', x: 0, y: 13.5, w: 1, h: 1 },
    { i: 'EnergyChart', x: 0, y: 14.5, w: 1, h: 2 },
    { i: 'UsersActivity', x: 0, y: 16.5, w: 1, h: 2 },
    { i: 'PaymentBreakdown', x: 0, y: 18.5, w: 1, h: 2 },
    { i: 'UserSignup', x: 0, y: 20.5, w: 1, h: 2 },
    { i: 'TimeBetweenTrans', x: 0, y: 22.5, w: 1, h: 2 },
    { i: 'TopUsers', x: 0, y: 24.5, w: 1, h: 2 },
    { i: 'TopVouchers', x: 0, y: 26.5, w: 1, h: 2 },
  ],
  xs: [
    { i: 'OverView', x: 0, y: 0, w: 1, h: 2 },
    { i: 'TransactionsStats', x: 0, y: 2, w: 1, h: 1.25 },
    { i: 'UsersStats', x: 0, y: 3.25, w: 1, h: 1 },
    { i: 'PeakHour', x: 0, y: 4.25, w: 1, h: 1.5 },
    { i: 'TopCities', x: 0, y: 5.75, w: 1, h: 1.5 },
    { i: 'TopSites', x: 0, y: 7.25, w: 1, h: 2.75 },
    { i: 'TimeFirstTrans', x: 0, y: 10, w: 1, h: 1.5 },
    { i: 'AverageDuration', x: 0, y: 11.5, w: 1, h: 1 },
    { i: 'EnergyChart', x: 0, y: 12.5, w: 1, h: 2 },
    { i: 'UsersActivity', x: 0, y: 14.5, w: 1, h: 2 },
    { i: 'PaymentBreakdown', x: 0, y: 16.5, w: 1, h: 2 },
    { i: 'UserSignup', x: 0, y: 18.5, w: 1, h: 2 },
    { i: 'TimeBetweenTrans', x: 0, y: 20.5, w: 1, h: 1.5 },
    { i: 'TopUsers', x: 0, y: 22, w: 1, h: 1.5 },
    { i: 'TopVouchers', x: 0, y: 23.5, w: 1, h: 1.5 },
  ],
  xxs: [
    { i: 'OverView', x: 0, y: 0, w: 1, h: 2 },
    { i: 'TransactionsStats', x: 0, y: 2, w: 1, h: 1.25 },
    { i: 'UsersStats', x: 0, y: 3.25, w: 1, h: 1 },
    { i: 'PeakHour', x: 0, y: 4.25, w: 1, h: 1.5 },
    { i: 'TopCities', x: 0, y: 5.75, w: 1, h: 1.5 },
    { i: 'TopSites', x: 0, y: 7.25, w: 1, h: 2.75 },
    { i: 'TimeFirstTrans', x: 0, y: 10, w: 1, h: 1.5 },
    { i: 'AverageDuration', x: 0, y: 11.5, w: 1, h: 1 },
    { i: 'EnergyChart', x: 0, y: 12.5, w: 1, h: 2 },
    { i: 'UsersActivity', x: 0, y: 14.5, w: 1, h: 1.8 },
    { i: 'PaymentBreakdown', x: 0, y: 16.3, w: 1, h: 1.8 },
    { i: 'UserSignup', x: 0, y: 18.1, w: 1, h: 1.8 },
    { i: 'TimeBetweenTrans', x: 0, y: 19.9, w: 1, h: 1.5 },
    { i: 'TopUsers', x: 0, y: 21.1, w: 1, h: 1.5 },
    { i: 'TopVouchers', x: 0, y: 22.9, w: 1, h: 1.5 },
  ],
}

const DashboardPage = ({ admin, editingAdminRole }) => {
  const { t } = useTranslation()
  const [progress, setProgress] = useState(0)
  const registeredCountries = admin.registeredCountries || []
  const hasSingleCountry = registeredCountries.length === 1
  const today = new Date()
  const dayOfMonth = today.getDate()
  const currentYear = today.getFullYear()

  const defaultPeriod = dayOfMonth <= 7 ? 'Last Month' : 'This Month'

  const selectData = useMemo(() => {
    return [
      { label: 'This Month', value: 'thisMonth' },
      { label: 'Last Month', value: 'lastMonth' },
      { label: 'Last 3 Months', value: 'last3Months' },
      { label: 'Last 6 Months', value: 'last6Months' },
      { label: 'This Year', value: 'thisYear' },
      { label: 'Last Year', value: 'lastYear' },
      ...Array.from({ length: 3 }, (_, i) => {
        const year = currentYear - 2 - i
        return { label: `${year}`, value: `${year}` }
      }),
    ]
  }, [currentYear])
  const [filters, setFilters] = useState(() => {
    const initial = []

    if (!hasSingleCountry && registeredCountries.length) {
      initial.push({
        type: IFFilterType.SELECT,
        title: 'Country',
        data: registeredCountries.map((c) => c.name),
        field: 'Country',
        value: registeredCountries[0].name,
        initialValue: registeredCountries[0].name,
        canClear: false,
      })
    }

    initial.push({
      type: IFFilterType.SELECT,
      title: 'Period',
      data: selectData.map((d) => d.label),
      field: 'Period',
      value: defaultPeriod,
      initialValue: defaultPeriod,
      canClear: false,
    })

    return initial
  })

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
  }
  const countryFilterOnly = useMemo(
    () => filters.filter((f) => f.field === 'Country'),
    [filters],
  )

  const selectedCountryName =
    filters.find((f) => f.field === 'Country')?.value ||
    registeredCountries?.[0]?.name

  const selectedCurrency = registeredCountries.find(
    (c) => c.name === selectedCountryName,
  )?.currency?.code

  const canView = editingAdminRole?.can(Actions.VIEW, Subjects.DASHBOARD)
  useEffect(() => {
    const errorHandler = (e) => {
      if (
        e.message?.includes(
          'ResizeObserver loop completed with undelivered notifications',
        )
      ) {
        const el = document.getElementById('webpack-dev-server-client-overlay')
        if (el) el.style.display = 'none'
      }
    }

    window.addEventListener('error', errorHandler)
    return () => window.removeEventListener('error', errorHandler)
  }, [])

  return (
    <div className={Styles.Container}>
      <div>
        <LoadingBar
          color={Colors.primary}
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
      </div>
      <div className={Styles.TopContainer}>
        <div className={Styles.GridContainer}>
          <div className={Styles.Filter}>
            <IFFilter
              filters={filters}
              onFilterChange={handleFilterChange}
              disableKeyword
              textFieldPlaceholder={t('Analytics.DashboardFilterPlaceholder')}
            />
          </div>
          <Scrollbars autoHide style={{ height: '100%' }}>
            <div>
              {canView && (
                <ResponsiveGridLayout
                  layouts={layouts}
                  breakpoints={{ lg: 1470, md: 1152, sm: 768, xs: 480, xxs: 0 }}
                  cols={{ lg: 4.01, md: 2, sm: 1, xs: 1, xxs: 1 }}
                  rowHeight={280}
                  autoSize
                  margin={[8, 8]}
                  containerPadding={[0, 0]}
                  isResizable={false}
                  isDraggable={false}
                  compactType="vertical"
                >
                  <div key="OverView">
                    <GraphCard
                      title={t('Analytics.Overview')}
                      icon={<IFsvg.Bolt />}
                      isSelectPicker={true}
                      graph={OverviewCard}
                      filter={filters}
                      selectData={selectData}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="PeakHour">
                    <GraphCard
                      title={t('Analytics.PeakHour')}
                      icon={<IFsvg.ModeHeat />}
                      isSelectPicker={true}
                      graph={PeakHourCard}
                      filter={filters}
                      selectData={selectData}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>

                  <div key="AverageDuration">
                    <GraphCard
                      title={t('Analytics.AverageDuration')}
                      icon={<IFsvg.AverageTime />}
                      isSelectPicker={true}
                      graph={AverageDurationCard}
                      filter={filters}
                      selectData={selectData}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="UsersActivity">
                    <GraphCard
                      title={t('Analytics.UsersActivity')}
                      icon={<IFsvg.UsersActivity />}
                      graph={UsersActivityCard}
                      filter={countryFilterOnly}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                      selectTitle={t('Analytics.AllTime')}
                    />
                  </div>
                  <div key="TopSites">
                    <GraphCard
                      title={t('Analytics.TopSites')}
                      icon={<IFsvg.MapPinPreview />}
                      isSelectPicker={true}
                      graph={TopSitesCard}
                      selectData={selectData}
                      filter={filters}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="TimeFirstTrans">
                    <GraphCard
                      title={t('Analytics.TimeForFirstCharge')}
                      icon={<IFsvg.ElectricCar />}
                      graph={TimeForFirstChargeCard}
                      filter={countryFilterOnly}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                      selectTitle={t('Analytics.AllTime')}
                    />
                  </div>
                  <div key="TransactionsStats">
                    <GraphCard
                      title={t('Analytics.TransactionsStats')}
                      icon={<IFsvg.QueryStats />}
                      graph={TransactionsStatsCard}
                      filter={countryFilterOnly}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                      selectTitle={t('Analytics.ThisMonth')}
                    />
                  </div>
                  <div key="UsersStats">
                    <GraphCard
                      title={t('Analytics.UsersStatistics')}
                      icon={<IFsvg.QueryStats />}
                      isSelectPicker={true}
                      graph={UsersStatisticsCard}
                      selectData={selectData}
                      filter={filters}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="TopUsers">
                    <GraphCard
                      title={t('Analytics.TopUsers')}
                      icon={<IFsvg.TopUsers />}
                      isSelectPicker={true}
                      graph={TopUsersCard}
                      selectData={selectData}
                      filter={filters}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="EnergyChart">
                    <GraphCard
                      title={t('Analytics.EnergyChart')}
                      icon={<IFsvg.MobileCharge />}
                      isSelectPicker={true}
                      graph={EnergyChartCard}
                      selectData={selectData}
                      filter={filters}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="PaymentBreakdown">
                    <GraphCard
                      title={t('Analytics.PaymentBreakdown')}
                      icon={<IFsvg.Payment />}
                      isSelectPicker={true}
                      graph={PaymentBreakdownCard}
                      selectData={selectData}
                      filter={filters}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="TopCities">
                    <GraphCard
                      title={t('Analytics.TopCities')}
                      icon={<IFsvg.Map />}
                      isSelectPicker={true}
                      graph={TopCitiesCard}
                      selectData={selectData}
                      filter={filters}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                  <div key="TimeBetweenTrans">
                    <GraphCard
                      title={t('Analytics.AvgBetweenSessions')}
                      icon={<IFsvg.EventRepeat />}
                      graph={TimeBetweenTransCard}
                      filter={countryFilterOnly}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                      selectTitle={t('Analytics.AllTime')}
                    />
                  </div>
                  <div key="UserSignup" style={{ minWidth: 0 }}>
                    <GraphCard
                      title={t('Analytics.UserSignup')}
                      icon={<IFsvg.PersonAdd />}
                      graph={UserSignupHeatmap}
                      filter={countryFilterOnly}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                      selectTitle={t('Analytics.AllTime')}
                    />
                  </div>
                  <div key="TopVouchers">
                    <GraphCard
                      title={t('Analytics.TopVouchers')}
                      icon={<IFsvg.Redeem />}
                      isSelectPicker={true}
                      graph={TopVouchersCard}
                      selectData={selectData}
                      filter={filters}
                      currency={selectedCurrency}
                      selectIcon={
                        <IFsvg.CalendarMonth
                          style={{ marginTop: 4 }}
                          height={16}
                          width={16}
                        />
                      }
                    />
                  </div>
                </ResponsiveGridLayout>
              )}
            </div>
          </Scrollbars>
        </div>
      </div>
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return {}
}
const mapStateToProps = (state) => ({
  admin: AuthSelectors.getUser(state),
  editingAdminRole: AuthSelectors.getEditingAdminRole(state),
})
export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage)
